function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import vent from 'elements/vent';
import A11yDialog from 'a11y-dialog';
export var dialogs = new (/*#__PURE__*/function () {
  function Dialogs() {
    var _this = this;
    _classCallCheck(this, Dialogs);
    var container = document.createElement('div');
    container.innerHTML = '<div id="dialogs"></div>';
    document.body.appendChild(container);
    var observer = new MutationObserver(function (mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;
          var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _node$matches;
              var node = _step2.value;
              if (!(node instanceof HTMLElement)) continue;
              if ((_node$matches = node.matches) !== null && _node$matches !== void 0 && _node$matches.call(node, '.a11y-dialog-container')) {
                _this._createDialog(node);
                node.dialog.show();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(document.getElementById('dialogs'), {
      childList: true
    });
    this.currentDialog = null;
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  return _createClass(Dialogs, [{
    key: "_createDialog",
    value: function _createDialog(item) {
      var _this2 = this;
      if (!item.dialog) {
        item.dialog = new A11yDialog(item);
        item.dialog.on('hide', function (elt) {
          _this2._lockBody(false);
          vent.publish('DIALOG:CLOSE');
        });
        item.dialog.on('show', function (e) {
          if (_this2.currentDialog) {
            _this2.currentDialog.hide();
            _this2.currentDialog = null;
          }
          _this2.currentDialog = e.target.dialog;
          _this2._lockBody(true);
          vent.publish('DIALOG:OPEN');
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      if (this.currentDialog) {
        this.currentDialog.hide();
        this.currentDialog = null;
      }
      document.querySelectorAll('[data-a11y-dialog]').forEach(function (item) {
        _this3._createDialog(item);
      });
      document.querySelectorAll('[data-auto-dialog]').forEach(function (item) {
        if (item.sent) return;
        setTimeout(function (_) {
          item.sent = true;
          item.click();
        }, 100);
      });
    }
  }, {
    key: "_lockBody",
    value: function _lockBody(lock) {
      var lockClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'stimulus-popup-open';
      if (lock) {
        document.body.lockTop = window.scrollY || window.pageYOffset || 0;
        // document.body.style.top = -document.body.lockTop / 10 + 'rem';
        document.body.classList.add(lockClass);
      } else {
        document.body.classList.remove(lockClass);
        // document.body.style.top = 0;
        // window.scroll({ left: 0, top: document.body.lockTop || 0, behavior: 'instant' });
      }
    }
  }]);
}())();